import React from 'react';
import renderHTML from 'react-render-html';
import { IMAGE_BASE_LINK } from '../../../../app-constants';
import { stripStartingAndEndingPTags } from '../../../ssm-homepage/ssm-homepage.actions';

const HeaderWithImage = (props) => {
  const { title, text, image } = props;
  return (
    <div className="row paddingS pl-0 pr-0 image-header">
      <div className="col-sm-12 col-md-6 image">
        <img alt={image} src={`${IMAGE_BASE_LINK}/${image}`} className="img-fluid" />
      </div>
      <div className="col-sm-12 col-md-6 text">
        <div id="main-heading" className="heading44 main-heading">{title}</div>
        <div id="main-description" className="description">{renderHTML(stripStartingAndEndingPTags(text))}</div>
      </div>
    </div>
  );
};

export default HeaderWithImage;
